var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSticked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "-29 0 511 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M274.152 305.66l-127.34-127.34-60.457 60.45c-5.437 5.437-5.89 14.097-1.039 20.066 8.645 10.668 8.836 26.32.438 37.21l-48.402 71.165c-10.305 13.363-8.825 32.02 3.53 44.375 12.473 12.473 31.18 13.734 44.395 3.535l71.149-48.402c10.8-8.313 26.789-8.047 37.183.422 5.98 4.84 14.657 4.414 20.094-1.024zm42.446-106.125l42.46-42.441-63.683-63.684-42.445 42.461zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M443.945 178.313c11.711-11.696 11.711-30.747 0-42.442L316.598 8.523c-11.403-11.375-31.07-11.343-42.414-.03L168.027 114.647c-11.59 11.528-11.859 30.555-.027 42.415L295.375 284.44c11.988 11.954 31.055 11.524 42.488-.058zm-53.054-10.61l-63.68 63.668c-5.863 5.863-15.36 5.863-21.223 0l-84.89-84.89c-5.86-5.86-5.86-15.36 0-21.223l63.668-63.68c5.859-5.86 15.359-5.863 21.222 0l84.903 84.902c5.859 5.86 5.863 15.36 0 21.223zM47.414 449.086c-8.492-2.5-16.367-6.754-23.332-12.621-2.617 1.265-4.941 3.066-6.477 5.64C.793 470.45.575 478.848.5 481.617.5 498.547 13.969 512 30.516 512s30.015-13.469 30.015-30.016c-.066-2.867-.398-10.273-13.117-32.898zm0 0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSticked);
export default __webpack_public_path__ + "static/media/sticked.5993c851.svg";
export { ForwardRef as ReactComponent };